var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 800,
    viewBox: "0 0 489 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_203)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.979 0.401123V290.719L3.42188 404.662L2.60938 404.193L27.724 362.505L245.979 0.401123Z",
    fill: "#868DAC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 448,
    width: 246,
    height: 352
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 448H246V800H0V448Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.979 595.943V799.573L0 448.63L245.979 595.943Z",
    fill: "#868DAC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.979 290.719V549.943L32.901 422.328L3.42188 404.661L245.979 290.719Z",
    fill: "#5F658B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.386 404.193L488.578 404.662L245.979 290.719V0.401123L464.271 362.505L489.386 404.193Z",
    fill: "#5F658B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M488.578 404.661L459.047 422.328L245.979 549.943V290.719L488.578 404.661Z",
    fill: "#434871"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_108_203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 448,
    width: 248,
    height: 352
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.667 448H492V800H244.667V448Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_108_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.995 448.63L246.021 799.62L245.979 799.573V595.943L491.995 448.63Z",
    fill: "#5F658B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 489,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth2);
export default __webpack_public_path__ + "static/media/eth2.652e0975c9947dac5239ee20bc5bc015.svg";
export { ForwardRef as ReactComponent };